import { getAllImagesByPatentIdApi } from 'library-@/apis/core_basic_api/patent';
import _ from 'lodash';
import $ from 'jquery';
import imageLoading from '../assets/images/loading/black-normal.gif';
import { intLazyLoadImg } from '../utils/lazyLoadImg';
import { getIsFreeView } from 'library-@/utils/patent-view-free-judgment-util';

const TextAndGraphMixin = {
    data() {
        return {
            DescImageList: {},
            DescImage240List: {},
            container: undefined,
        };
    },
    computed: {
        isCn() {
            const types = _.get(this.patent, 'TYPE', []).map(str => str.toUpperCase());
            return types.includes('CN');
        },
    },
    mounted() {
        this.$$el = $(this.$el);
        this.container = this.$$el;
    },
    methods: {
        getAllImagesByPatentId(patentId) {
            if (getIsFreeView()) return;
            getAllImagesByPatentIdApi(patentId).then(res => {
                this.DescImageList = _.get(res, `data.data.${patentId}.OFFICIAL_IMAGE`, {});
                this.DescImage240List = _.get(res, `data.data.${patentId}.OFFICIAL_IMAGE_240`, {});
                this.bindLazyLoadImg();
            }).catch(() => { });
        },
        bindLazyLoadImg() {
            const vm = this;
            this.$nextTick(() => {
                const list = this.DescImageList;
                const $imgs = this.$$el.find('img.img-anchor');
                $imgs.each(function() {
                    const $this = $(this);
                    const imageObj = list[$this.attr('img-id')];
                    if (imageObj && imageObj.url && $this.attr('src') !== imageObj.url) {
                        const width = (imageObj.type !== 'inline' && vm.isCn) ? '50%' : imageObj.width;
                        $this.attr('data-src', imageObj.url)
                            .attr('data-width', width)
                            .attr('src', imageLoading)
                            .attr('type', imageObj.type)
                            .addClass('img-loading');
                        if (imageObj.width) {
                            // CFD-20810 max-width: none造成开启翻译时，图片宽度不正确，遮盖住翻译内容， 先注释掉
                            // $this.attr('data-max-width', 'none');
                        }
                        intLazyLoadImg($this[0], () => {
                            vm.setTranslationAlign();
                            // 手动触发resize以便于对比相似段落tag的重新定位
                            window.dispatchEvent(new Event('resize'));
                        });
                    }
                });
            });
        },
    },
};

export {
    TextAndGraphMixin,
};
